import { Component, Input, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-label-required',
  templateUrl: './label-required.component.html',
  styleUrls: ['./label-required.component.scss'],
})
export class LabelRequiredComponent implements OnInit {
  @Input()
  label = '';

  @Input()
  field = '';

  @Input()
  errors!: ValidationErrors | null;

  constructor() {}

  ngOnInit(): void {}
}
